import React from 'react';
import {View} from 'MWC';
import tpl from '../templates/main.jsx';
import PropTypes from 'prop-types';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INTERACTIVE,
            currentSlide: 0,
            startX: 0,
            slidesToShow: 1,
            isLastFullyVisible: false,
            mode: 'recommended',
            isMobile: window.innerWidth <= 450,
            isTablet: window.innerWidth <= 850 && window.innerWidth >= 767,
            isDesktop: window.innerWidth > 850,
            isMiddle: window.innerWidth < 767 && window.innerWidth > 450,
            isOpen: false,
            userInteractedWithSliderMore: false,
            userInteractedWithSliderProposal: false
        };

        this.dropdownRef = React.createRef();
        this.sliderRefMore = React.createRef();
        this.sliderRefTabs = React.createRef();
        this.sliderRefProposal = React.createRef();
        this.sliderRefContainer = React.createRef();
        this.sliderRefProposalContainer = React.createRef();
        this.navigate = this.navigate.bind(this);
        this.nextSlide = this.nextSlide.bind(this);
        this.prevSlide = this.prevSlide.bind(this);
        this.setCurrentSlide = this.setCurrentSlide.bind(this);
        this.handleMouseDown = this.handleMouseDown.bind(this);
        this.handleMouseUp = this.handleMouseUp.bind(this);
        this.toggleMode = this.toggleMode.bind(this);
        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.prevProposalSlide = this.prevProposalSlide.bind(this);
        this.nextProposalSlide = this.nextProposalSlide.bind(this);
        this.handleSwipe = this.handleSwipe.bind(this);
        this.handleSwipeProposal = this.handleSwipeProposal.bind(this);
        this.heroRef = React.createRef();
        return this;
    }

    handleScrollDownloadAppVisibility = () => {
        if (!this.heroRef.current || !this.props.onToggleDownloadApp) return;

        const heroBottom = this.heroRef.current.getBoundingClientRect().bottom;
        const headerHeight = 80;
        const downloadAppHeight = 104;

        const isVisible = heroBottom - headerHeight - downloadAppHeight > 0;

        this.props.onToggleDownloadApp(isVisible);
    };

    updateWidth = () => {
        this.setState({
            isMobile: window.innerWidth <= 450,
            isTablet: window.innerWidth <= 850 && window.innerWidth >= 767,
            isDesktop: window.innerWidth > 850,
            isMiddle: window.innerWidth < 767 && window.innerWidth > 450
        });
    };

    enableObserverMore() {
        this.observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && !this.state.userInteractedWithSliderMore) {
                    this.sliderRefMore.current?.slickPlay();
                } else {
                    this.sliderRefMore.current?.slickPause();
                }
            },
            {threshold: 0.01}
        );

        if (this.sliderRefContainer.current) {
            this.observer.observe(this.sliderRefContainer.current);
        }
    }

    enableObserverProposal() {
        this.observer2 = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && !this.state.userInteractedWithSliderProposal) {
                    this.sliderRefProposal.current?.slickPlay();
                } else {
                    this.sliderRefProposal.current?.slickPause();
                }
            },
            {threshold: 0.01}
        );

        if (this.sliderRefProposalContainer.current) {
            this.observer2.observe(this.sliderRefProposalContainer.current);
        }
    }

    waitingForDOMProposal() {
        const waitForElement2 = () => {
            const element = this.sliderRefProposalContainer.current;

            if (element.getBoundingClientRect().top < window.innerHeight) {
                if (this.sliderRefProposal.current) {
                    setTimeout(() => {
                        this.sliderRefProposal.current.slickPlay();
                    }, 1000);
                }
            } else {
                requestAnimationFrame(waitForElement2);
            }
        };

        requestAnimationFrame(waitForElement2);
    }

    waitingForDOMMore() {
        const waitForElement = () => {
            const element = this.sliderRefContainer.current;

            if (element.getBoundingClientRect().top < window.innerHeight) {
                if (this.sliderRefMore.current) {
                    setTimeout(() => {
                        this.sliderRefMore.current.slickPlay();
                    }, 1000);
                }
            } else {
                requestAnimationFrame(waitForElement);
            }
        };

        requestAnimationFrame(waitForElement);
    }

    componentDidMount() {
        this.updateSlidesToShow();
        window.addEventListener('resize', this.updateSlidesToShow);
        window.addEventListener('resize', this.updateWidth);
        document.addEventListener('click', this.handleClickOutside);

        this.enableObserverMore();
        this.waitingForDOMMore();

        this.enableObserverProposal();
        this.waitingForDOMProposal();

        window.addEventListener('scroll', this.handleScrollDownloadAppVisibility);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateSlidesToShow);
        window.removeEventListener('resize', this.updateWidth);
        document.removeEventListener('click', this.handleClickOutside);

        if (this.observer && this.sliderRefContainer.current) {
            this.observer.unobserve(this.sliderRefContainer.current);
        }

        if (this.observer2 && this.sliderRefProposalContainer.current) {
            this.observer2.unobserve(this.sliderRefProposalContainer.current);
        }

        window.removeEventListener('scroll', this.handleScrollDownloadAppVisibility);
    }

    handleSwipe = () => {
        this.setState({userInteractedWithSliderMore: true}, () => {
            this.sliderRefMore.current?.slickPause();
        });
    };

    handleSwipeProposal = () => {
        this.setState({userInteractedWithSliderProposal: true}, () => {
            this.sliderRefProposal.current?.slickPause();
        });
    };

    handleClickOutside = event => {
        if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
            this.setState({isOpen: false});
        }
    };

    toggleDropdown = () => {
        this.setState(prevState => ({isOpen: !prevState.isOpen}));
    };

    toggleMode = mode => {
        this.setState({mode: mode, isOpen: false});
        setTimeout(() => {
            if (!this.state.userInteractedWithSliderProposal) {
                this.sliderRefProposal.current?.slickPlay();
            }
        }, 500);
    };

    checkLastSlideVisibility = () => {
        if (!this.sliderRefContainer.current) return;

        const slider = this.sliderRefContainer.current;
        const slides = slider.querySelectorAll('.slick-slide');

        if (slides.length === 0) return;

        const lastSlide = slides[slides.length - 1];
        const sliderRect = slider.getBoundingClientRect();
        const lastSlideRect = lastSlide.getBoundingClientRect();

        const isFullyVisible = lastSlideRect.right <= sliderRect.right;

        this.setState({isLastFullyVisible: isFullyVisible});
    };

    updateSlidesToShow = () => {
        if (this.sliderRefContainer.current) {
            const sliderWidth = this.sliderRefContainer.current.offsetWidth;
            if (!sliderWidth) return;

            const slidesToShow = Math.floor(sliderWidth / 392);
            this.setState({slidesToShow});
            this.checkLastSlideVisibility();
        }
    };

    handleSlideChange = index => {
        this.setState({currentSlide: index});
        this.checkLastSlideVisibility();
    };

    navigate = (...args) => {
        return this.context.app.navigate(...args);
    };

    prevProposalSlide = () => {
        this.sliderRefProposal.current.slickPrev();
        this.sliderRefProposal.current?.slickPause();
        this.setState({userInteractedWithSliderProposal: true});
    };

    nextProposalSlide = () => {
        this.sliderRefProposal.current.slickNext();
        this.sliderRefProposal.current?.slickPause();
        this.setState({userInteractedWithSliderProposal: true});
    };

    nextSlide = () => {
        this.sliderRefMore.current.slickNext();
        this.sliderRefMore.current?.slickPause();
        this.setState({userInteractedWithSliderMore: true});
    };

    prevSlide = () => {
        this.sliderRefMore.current.slickPrev();
        this.sliderRefMore.current?.slickPause();
        this.setState({userInteractedWithSliderMore: true});
    };

    setCurrentSlide = value => {
        this.setState({currentSlide: value});
    };

    handleMouseDown = event => {
        this.setState({startX: event.clientX});
    };

    handleMouseUp = (event, onClick) => {
        const deltaX = Math.abs(event.clientX - this.state.startX);

        if (deltaX < 10) {
            onClick();
        }
    };

    static contextTypes = {
        app: PropTypes.object
    };

    static displayName = 'HomeNew';
}
